import { Reveal } from "@/components/Reveal";
import { Eye, Split, TrendingUp, Ban } from "lucide-react";

const CHAPTERS = [
  {
    n: "01",
    icon: Eye,
    title: "A Visible Price",
    body: "Every vehicle carries its own price — disclosed in full before you sign anything. No surprises after the fact, no fine print that moves the goalposts.",
    span: "md:col-span-7",
  },
  {
    n: "02",
    icon: Split,
    title: "A Separated Charge",
    body: "Your monthly payment is split openly: the rental & service component on one side, your ownership allocation on the other. You always know what builds your stake.",
    span: "md:col-span-5",
  },
  {
    n: "03",
    icon: TrendingUp,
    title: "Scheduled Ownership",
    body: "Every month a fixed allocation chips away at your ownership balance — and a written statement proves your progress. 48 or 60 months to the title.",
    span: "md:col-span-5",
  },
  {
    n: "04",
    icon: Ban,
    title: "No Hidden Balloon",
    body: "The term is defined, the schedule is signed, and there is no undisclosed residual waiting at the end. Your early-settlement figure is always clear.",
    span: "md:col-span-7",
  },
];

export default function Manifesto() {
  return (
    <section data-testid="manifesto-section" className="py-24 md:py-32">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-sky-300 font-bold mb-4">The CompCar manifesto</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-black text-white max-w-3xl mb-16">
            Transparency isn't a slogan here. It's the product.
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {CHAPTERS.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08} className={c.span}>
              <div
                data-testid={`manifesto-chapter-${c.n}`}
                className="group h-full bg-[#122659] border border-sky-300/20 rounded-xl p-8 md:p-10 hover:border-[#F57C00]/50 transition-colors duration-300 relative overflow-hidden"
              >
                <span className="font-display text-7xl font-black text-outline absolute -top-2 right-4 select-none group-hover:[-webkit-text-stroke-color:rgba(245,124,0,0.5)] transition-all duration-300">
                  {c.n}
                </span>
                <c.icon size={28} className="text-[#F57C00] mb-6" />
                <h3 className="font-display text-xl sm:text-2xl font-bold text-white mb-3">{c.title}</h3>
                <p className="text-sm md:text-base text-slate-400 leading-relaxed max-w-md">{c.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
